<ng-container
  *ngIf="redeemCashLoyaltyProgram && redeemCashLoyaltyProgram.transferRate"
  [formGroup]="transferAmountForm">
  <div class="input-group">
    <label class="amount-form-label" for="sourceAmount">{{
      loyaltyCurrencyName
    }}</label>

    <rd-shared-counter
      formControlName="sourceAmount"
      [config]="counterConfig"
      [translationsConfig]="counterTranslationsConfig">
      <ng-container errorCases>
        <mat-error class="required-source-amount" *ngIf="isSourceAmountEmpty()">
          {{ 'redeem_cash_v2.checkout.error.required_amount' | translate }}
        </mat-error>

        <mat-error
          class="not-number-source-amount"
          *ngIf="isSourceAmountNotNumber()">
          {{ 'redeem_cash_v2.checkout.error.non_number_amount' | translate }}
        </mat-error>
      </ng-container>
    </rd-shared-counter>
  </div>
  <span class="transfer-icon">
    <rd-shared-icon
      [iconSymbol]="'icon-icn-transfer'"
      [iconTheme]="'link'"></rd-shared-icon>
  </span>

  <div class="input-group">
    <label class="amount-form-label" for="targetAmount">
      {{
        'redeem_cash_v2.checkout.cashback'
          | translate: { currency: targetCurrency }
      }}</label
    >
    <div
      class="target-input-container"
      [class.target-input-readonly]="readOnlyCashFormField">
      <mat-form-field [color]="'accent'" class="mat-field">
        <input
          matInput
          class="target-amount"
          [readonly]="readOnlyCashFormField || currencyConversionLoading"
          type="text"
          formControlName="targetAmount"
          [placeholder]="targetDenomination | localizeNumber"
          aria-atomic="true"
          [attr.aria-label]="targetCurrency"
          [attr.aria-live]="'polite'"
          [attr.aria-disabled]="
            readOnlyCashFormField || currencyConversionLoading
          " />
      </mat-form-field>
    </div>
    <mat-hint *ngIf="!readOnlyCashFormField" class="target-amount-hint">{{
      'redeem_cash_v2.checkout.hint.nearest_round_number'
        | translate
          : {
              amount: targetDenomination | localizeNumber
            }
    }}</mat-hint>
    <mat-error class="required-target-amount" *ngIf="isTargetAmountEmpty()">
      {{ 'redeem_cash_v2.checkout.error.required_amount' | translate }}
    </mat-error>
    <mat-error
      class="not-number-target-amount"
      *ngIf="isTargetAmountNotNumber()">
      {{ 'redeem_cash_v2.checkout.error.non_number_amount' | translate }}
    </mat-error>
  </div>
</ng-container>
